// queries/getContactMe.ts
import datoCMSClient from './datoCMSClient';
import { ContactMe } from '../types';

const GET_CONTACT_ME = `
  query {
    contactMe {
      profilePicture {
        url
      }
      name
      title
      summary
      companyUniversity
      linkedinLink
      email
      phoneNumber
    }
  }
`;

// Fallback data based on your content
const FALLBACK_DATA: ContactMe = {
  profilePicture: { url: "https://picsum.photos/200/200?random=1" }, // Placeholder profile image
  name: "Mantavya Mahajan",
  title: "Computer Science & Mathematics Student, Gen AI Technical Advisor",
  summary: "Passionate about using technology to solve real-world problems, with experience in AI, full-stack development, and research.",
  companyUniversity: "Penn State University",
  linkedinLink: "https://www.linkedin.com/in/mantavya-mahajan-42972721b/",
  email: "mantavyamahajan08@gmail.com",
  phoneNumber: "+1 (564) 544-4219"
};

export async function getContactMe(): Promise<ContactMe> {
  try {
    const data = await datoCMSClient.request<{ contactMe: ContactMe }>(GET_CONTACT_ME);
    return data.contactMe;
  } catch (error) {
    console.warn("Error fetching contact data, using fallback data:", error);
    return FALLBACK_DATA;
  }
}